export const FLAGSMITH_KEYS = {
  KI_3981_REMOVE_USER_ACCOUNT_REQUEST: 'ki-3981-remove-user-account-request',
  KI_4317_REPORTS_V2_METABASE: 'ki-4317-reports-v2-metabase',
};
